// @flow

import React from 'react';
import SearchContext from '../../utils/searchContext';
import SearchableTextInput from '../../common/SearchableTextInput';
import SelectVocabularyValue from '../../common/SelectVocabularyValue';

const SearchFiltersContainer = () => {
  return (
    <SearchContext.Consumer>
      {({ setFilters, translations, vocabulary }) => {
        return (
          <div className="form-search-wrapper">
            <form>
              <div className="label">
                {translations && translations.search_results_filters_label
                  ? translations.search_results_filters_label
                  : 'Filter results'}
              </div>

              <div className="search-course-input">
                <SearchableTextInput
                  onUpdateValue={setFilters}
                  translations={translations}
                />
              </div>
              <SelectVocabularyValue
                id="master_type"
                onUpdateSelect={(value) => setFilters({ master_type: value })}
                emptyValueLabel={translations.master_type_label}
                vocabulary={vocabulary.MasterTypesCatalog}
              />
              <SelectVocabularyValue
                id="disciplinary_area"
                onUpdateSelect={(value) =>
                  setFilters({ disciplinary_area: value })
                }
                emptyValueLabel={translations.disciplinary_area_label}
                vocabulary={vocabulary.DisciplinaryAreasCatalog}
              />
              <SelectVocabularyValue
                id="educational_activity"
                onUpdateSelect={(value) =>
                  setFilters({ educational_activity: value })
                }
                emptyValueLabel={translations.educational_activity_label}
                vocabulary={vocabulary.EducationalActivitiesCatalog}
              />
            </form>
          </div>
        );
      }}
    </SearchContext.Consumer>
  );
};

export default SearchFiltersContainer;
